import React from 'react';
import { gettingStartedSteps } from '../../data/landingContent';
export function GettingStarted() {
  return <section id="getting-started" className="scroll-mt-6 border-y border-stone-200 bg-[#A6B6F8]/15" data-id="element-66" data-mp="f7wayf8m75d4">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-[0.72fr_1.28fr] lg:gap-20" data-id="element-67" data-mp="k8k0sxl3xg5r">
        <div data-id="element-68" data-mp="p50yoji3z8w1">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-69" data-mp="3nor432zm1be0">
            A quick guide
          </p>
          <h2 className="font-display mt-3 text-2xl font-bold uppercase leading-tight tracking-[0.02em] sm:text-[2.1rem]" data-id="element-70" data-mp="3snaogyyk2f49">
            Getting started.
          </h2>
          <p className="mt-4 text-base leading-7 text-[#3A3A3A]" data-id="element-71" data-mp="1fogiu4szqhl">
            Get your business up and running with Credit Manager in three simple
            steps.
          </p>
          <a href="/signup" className="font-display mt-7 inline-flex items-center gap-2 bg-[#041F60] px-9 py-4 text-[13px] font-bold uppercase tracking-[0.13em] text-white transition-colors duration-150 hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2" data-id="element-72" data-mp="34xzohjp14or6">
            Start your free trial
          </a>
        </div>

        <ol className="border-t border-stone-300" data-id="element-73" data-mp="15jczr725p1zi">
          {gettingStartedSteps.map(step => <li key={step.number} className="grid gap-5 border-b border-stone-300 py-8 sm:grid-cols-[72px_1fr] sm:items-start sm:gap-7" data-id="element-74" data-mp="10ltazd7u16tb">
              <span className="grid h-14 w-14 place-items-center bg-[#041F60] font-mono text-xl font-medium tracking-tight text-[#4BE4FF]" data-id="element-75" data-mp="rklpjvqf00gn">
                {step.number}
              </span>
              <div className="pt-0.5 sm:pt-1.5" data-id="element-76" data-mp="hoa8ytjskoge">
                <h3 className="font-display text-lg font-bold uppercase tracking-[0.05em]" data-id="element-77" data-mp="hpldivl2a08k">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-[#3A3A3A]" data-id="element-78" data-mp="2c2b6nb3lv5ew">
                  {step.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}